<template>
    <div></div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'TheAdminIndex',
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        async setup() {
            //setup dynamic header
            let header = 'Trang chủ';
            this.setupHeader({ header });
        },
    },
    mounted() {
        this.setup();
    }
}
</script>